import { useEffect, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import Particles from "@/components/Particles";
import Preloader from "@/components/Preloader";
import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Specialties from "@/components/Specialties";
import ProductCatalogSection from "@/components/ProductCatalogSection";
import Comparison from "@/components/Comparison";
import UseCases from "@/components/UseCases";
import Manifesto from "@/components/Manifesto";
import About from "@/components/About";
import FAQ from "@/components/FAQ";
import QuoteSection from "@/components/QuoteSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

// Plays only on a full page load, not on client-side route changes back to "/".
let splashShown = false;

export default function Landing() {
  const [showSplash, setShowSplash] = useState(!splashShown);

  useEffect(() => {
    splashShown = true;
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-[#05070A] text-gray-200 antialiased overflow-x-clip">
      <AnimatePresence>
        {showSplash && <Preloader onDone={() => setShowSplash(false)} />}
      </AnimatePresence>
      <Particles />
      <div className="halo halo-gold top-[-22%] left-[-12%]" />
      <div className="halo halo-wine bottom-[-35%] right-[-18%]" />
      <div className="relative z-10">
        <TopBar />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Specialties />
          <ProductCatalogSection />
          <Comparison />
          <UseCases />
          <Manifesto />
          <About />
          <FAQ />
          <QuoteSection />
        </main>
        <Footer />
      </div>
      <WhatsAppButton />
    </div>
  );
}
